export const FAKE_ORDER_LIST = [
  {
    "title": "Microsoft 365 技術體驗營(單天統一報名)",
    "alias": "modernweb2021",
    "type": "online",
    "seriesNum": "BG3XA",
    "regStatus": "WAITING",
    "dateTimeRange": "2021/11/01(ㄧ) (00:00-16:00)",
    "inProgress": 0,
    "brands": [
        {
            "alias": "aimetis",
            "logo": "https://assets.codepen.io/1759070/logo_1.svg",
        },
    ]
  },
  {
    "title": "Modernweb 2021(單天依場次報名)",
    "alias": "modernweb2021",
    "type": "online",
    "seriesNum": "BG3XA",
    "regStatus": "CANCELED",
    "dateTimeRange": "2021/11/02(二) (14:00-14:40)",
    "inProgress": 0,
    "brands": [
        {
            "alias": "aimetis",
            "logo": "https://assets.codepen.io/1759070/logo_1.svg",
        },
        {
            "alias": "f5",
            "logo": "https://assets.codepen.io/1759070/logo_1.svg",
        }
    ]
  },
  {
    "title": "IxDTW 互動設計年會 2021（多天依照場次報名）",
    "alias": "modernweb2021",
    "type": "physical",
    "seriesNum": "BG3XA",
    "regStatus": "PENDING",
    "dateTimeRange": "2021/11/01(ㄧ) (14:00-14:40)",
    "inProgress": 0,
    "brands": [
        {
            "alias": "aimetis",
            "logo": "https://assets.codepen.io/1759070/logo_1.svg",
        },
        {
            "alias": "f5",
            "logo": "https://assets.codepen.io/1759070/logo_1.svg",
        }
    ]
  },
  {
    "title": "PyConTW 2021(多天統一報名)",
    "alias": "modernweb2021",
    "type": "physical",
    "seriesNum": "BG3XA",
    "regStatus": "CONFIRMED",
    "dateTimeRange": "2021/11/01(ㄧ) (14:00-14:40)",
    "inProgress": 0,
    "brands": [
        {
            "alias": "aimetis",
            "logo": "https://assets.codepen.io/1759070/logo_1.svg",
        },
        {
            "alias": "f5",
            "logo": "https://assets.codepen.io/1759070/logo_1.svg",
        }
    ]
  },
  {
    "title": "如何設計並引導一場共創工作坊如何設計並引導一場共創工作坊？(單天依場次報名)",
    "alias": "modernweb2021",
    "type": "online",
    "seriesNum": "BG3XA",
    "regStatus": "BLOCKED",
    "dateTimeRange": "2021/11/01(ㄧ) (14:00-14:40)",
    "inProgress": 0,
    "brands": [
        {
            "alias": "aimetis",
            "logo": "https://assets.codepen.io/1759070/logo_1.svg",
        },
        {
            "alias": "f5",
            "logo": "https://assets.codepen.io/1759070/logo_1.svg",
        }
    ]
  },
  {
    "title": "Modernweb 2021(單天依場次報名)",
    "alias": "modernweb2021",
    "type": "physical",
    "seriesNum": "BG3XA",
    "regStatus": "CONFIRMED",
    "dateTimeRange": "2021/11/01(ㄧ) (14:00-14:40)",
    "inProgress": 0,
    "brands": [
        {
            "alias": "aimetis",
            "logo": null,
        },
    ]
  }
]
// 單天 實體 統一
const FAKE_ORDER_ITEM_PHYSICAL_SINGLE_IMPARTIAL = {
  "title": "Modernweb 2021(單天實體統一報名)",
  "alias": "modernweb2021",
  "dateType": "single",
  "type": "physical", // 實體
  "registrationType": "impartial", // 統一
  "seriesNum": "IU767",
  "regStatus": "CONFIRMED",
  "dateTimeRange": "2021/11/01(ㄧ) (10:00-14:40)",
  "locationName": "張榮發國際會議中心",
  "fullAddress": "臺北市中正區中山南路11號11樓",
  "lat": 25.1234567,
  "lng": 121.02564,
  "qrcode": "5JIEkZF6sMSjftqbQbdqpODdSqONfIU9iEh6FvUx7T9WooCVUwnrK4cxYM9jz7MUywV2ehYDVHQCr1GrRsxbNMnFRDEcjzcueSVU6OzMZe74JL3lfMiRZTivP5q2d8pw",
  "orders": [
      // {
      //     "orderNum": "ZERONE2110250007",
      //     "fullName": "傅惠貞",
      //     "gender": "male",
      //     "email": "turbo@hotmail.com.tw",
      //     "phoneCode": "+886",
      //     "phoneNumber": "0953053253",
      //     "note": null
      // },
      {
        "orderNum": "ZERONE21123457820",
        "fullName": "傅惠貞",
        "gender": "male",
        "email": "turbo@hotmail.com.tw",
        "phoneCode": "+886",
        "phoneNumber": "0953053253",
        "note": null
      }
  ],
  "sessions": [
      {
          "date": "2021-11-01",
          "sessions": [
              {
                  "title": "Digital and Application Innovation2",
                  "startTime": "09:00",
                  "endTime": "10:40",
                  "checkinStatus": "NOSHOW",
                  "info": {
                    "introtext": 'test',
                    "personnels": [
                      {
                        "name": "Jordan",
                        "categoryTitle": "工程師",
                        "companyName": "詠大心創意國際",
                        "title": "後端工程師",
                        "avatar": "avatar.jpg",
                        "description": null
                      },
                      {
                        "name": "Jerry",
                        "categoryTitle": "工程師",
                        "companyName": "詠大心創意國際",
                        "title": "後端工程師",
                        "avatar": "avatar.jpg",
                        "description": null
                      }
                    ],
                    "files": [],

                  }
              },
              {
                  "title": "Digital and Application Innovation",
                  "startTime": "10:00",
                  "endTime": "12:40",
                  "checkinStatus": "COMPLETED",
                  "info": {
                    "introtext": 'test',
                    "personnels": [
                      {
                        "name": "Jordan",
                        "categoryTitle": "工程師",
                        "companyName": "詠大心創意國際",
                        "title": "後端工程師",
                        "avatar": "avatar.jpg",
                        "description": null
                      },
                      {
                        "name": "Jerry",
                        "categoryTitle": "工程師",
                        "companyName": "詠大心創意國際",
                        "title": "後端工程師",
                        "avatar": "avatar.jpg",
                        "description": null
                      }
                    ],
                    "files": [],

                  }
              },
              {
                  "title": "從 React 到 React Native 到 React Native Web 開發與設計須知",
                  "startTime": "12:45",
                  "endTime": "13:05",
                  "checkinStatus": "FORBIDDEN",
                  "info": null, 
              },
              {
                  "title": "善用UX來提升UU：打造滿足新手和專家的UI",
                  "startTime": "13:50",
                  "endTime": "16:30",
                  "checkinStatus": "CHECKIN",
                  "info": {
                    "introtext": 'test',
                    "personnels": [
                      {
                        "name": "Jordan",
                        "categoryTitle": "工程師",
                        "companyName": "詠大心創意國際",
                        "title": "後端工程師",
                        "avatar": "avatar.jpg",
                        "description": null
                      },
                      {
                        "name": "Jerry",
                        "categoryTitle": "工程師",
                        "companyName": "詠大心創意國際",
                        "title": "後端工程師",
                        "avatar": "avatar.jpg",
                        "description": null
                      }
                    ],
                    "files": [],

                  }
              }
          ]
      }
  ],
  "meal": [
      {
          "date": "2021-11-01",
          "value": "葷食餐點"
      }
  ],
  "brands": [
      {
          "alias": "aimetis",
          "logo": null
      },
      {
          "alias": "f5",
          "logo": null
      }
  ]
}
// 多天 線上 場次
const FAKE_ORDER_ITEM_ONLINE_SINGLE_PARTIAL = {
  "title": "Modernweb 2021(多天依場次報名)",
  "alias": "modernweb2021",
  "dateType": "physical",
  "type": "online",
  "registrationType": "partial",
  "seriesNum": "IU767",
  "regStatus": "CONFIRMED",
  "dateTimeRange": "2021/11/01(ㄧ) (14:00-14:40)",
  "locationName": "",
  "fullAddress": "",
  "lat": null,
  "lng": null,
  "qrcode": "5JIEkZF6sMSjftqbQbdqpODdSqONfIU9iEh6FvUx7T9WooCVUwnrK4cxYM9jz7MUywV2ehYDVHQCr1GrRsxbNMnFRDEcjzcueSVU6OzMZe74JL3lfMiRZTivP5q2d8pw",
  "orders": [
      {
          "orderNum": "ZERONE2110250007",
          "fullName": "傅惠貞",
          "gender": "male",
          "email": "turbo@hotmail.com.tw",
          "phoneCode": "+886",
          "phoneNumber": "0953053253",
          "note": null
      },
      {
          "orderNum": "ZERONE2110382501",
          "fullName": "傅惠貞",
          "gender": "male",
          "email": "turbo@hotmail.com.tw",
          "phoneCode": "+886",
          "phoneNumber": "0953053253",
          "note": null
      }
  ],
  "sessions": [
    {
        "date": "2021-11-01",
        "sessions": [
            {
                "title": "Digital and Application Innovation2",
                "startTime": "09:00",
                "endTime": "10:40",
                "checkinStatus": "NOSHOW",
                "info": {
                  "introtext": 'test',
                  "personnels": [
                    {
                      "name": "Jordan",
                      "categoryTitle": "工程師",
                      "companyName": "詠大心創意國際",
                      "title": "後端工程師",
                      "avatar": "avatar.jpg",
                      "description": null
                    },
                    {
                      "name": "Jerry",
                      "categoryTitle": "工程師",
                      "companyName": "詠大心創意國際",
                      "title": "後端工程師",
                      "avatar": "avatar.jpg",
                      "description": null
                    }
                  ],
                  "files": [],
                  "link": 'https://youtu.be/a1dgx4'
                }
            },
            {
                "title": "Digital and Application Innovation",
                "startTime": "10:00",
                "endTime": "12:40",
                "checkinStatus": "COMPLETED",
                "info": {
                  "introtext": 'test',
                  "personnels": [
                    {
                      "name": "Jordan",
                      "categoryTitle": "工程師",
                      "companyName": "詠大心創意國際",
                      "title": "後端工程師",
                      "avatar": "avatar.jpg",
                      "description": null
                    },
                    {
                      "name": "Jerry",
                      "categoryTitle": "工程師",
                      "companyName": "詠大心創意國際",
                      "title": "後端工程師",
                      "avatar": "avatar.jpg",
                      "description": null
                    }
                  ],
                  "files": [],

                }
            },
            {
                "title": "從 React 到 React Native 到 React Native Web 開發與設計須知",
                "startTime": "12:45",
                "endTime": "13:05",
                "checkinStatus": "FORBIDDEN",
                "info": null, 
            },
            {
                "title": "善用UX來提升UU：打造滿足新手和專家的UI",
                "startTime": "13:50",
                "endTime": "16:30",
                "checkinStatus": "CHECKIN",
                "info": {
                  "introtext": 'test',
                  "personnels": [
                    {
                      "name": "Jordan",
                      "categoryTitle": "工程師",
                      "companyName": "詠大心創意國際",
                      "title": "後端工程師",
                      "avatar": "avatar.jpg",
                      "description": null
                    },
                    {
                      "name": "Jerry",
                      "categoryTitle": "工程師",
                      "companyName": "詠大心創意國際",
                      "title": "後端工程師",
                      "avatar": "avatar.jpg",
                      "description": null
                    }
                  ],
                  "files": [],

                }
            }
        ]
    },
    {
      "date": "2021-11-02",
      "sessions": [
          {
              "title": "Digital and Application Innovation2",
              "startTime": "09:00",
              "endTime": "10:40",
              "checkinStatus": "NOSHOW",
              "info": {
                "introtext": 'test',
                "personnels": [
                  {
                    "name": "Jordan",
                    "categoryTitle": "工程師",
                    "companyName": "詠大心創意國際",
                    "title": "後端工程師",
                    "avatar": "avatar.jpg",
                    "description": null
                  },
                  {
                    "name": "Jerry",
                    "categoryTitle": "工程師",
                    "companyName": "詠大心創意國際",
                    "title": "後端工程師",
                    "avatar": "avatar.jpg",
                    "description": null
                  }
                ],
                "files": [],
                "link": 'https://youtu.be/a1dgx4'
              }
          },
          {
              "title": "Digital and Application Innovation",
              "startTime": "10:00",
              "endTime": "12:40",
              "checkinStatus": "COMPLETED",
              "info": {
                "introtext": 'test',
                "personnels": [
                  {
                    "name": "Jordan",
                    "categoryTitle": "工程師",
                    "companyName": "詠大心創意國際",
                    "title": "後端工程師",
                    "avatar": "avatar.jpg",
                    "description": null
                  },
                  {
                    "name": "Jerry",
                    "categoryTitle": "工程師",
                    "companyName": "詠大心創意國際",
                    "title": "後端工程師",
                    "avatar": "avatar.jpg",
                    "description": null
                  }
                ],
                "files": [],

              }
          },
          {
              "title": "從 React 到 React Native 到 React Native Web 開發與設計須知",
              "startTime": "12:45",
              "endTime": "13:05",
              "checkinStatus": "FORBIDDEN",
              "info": null, 
          },
          {
              "title": "善用UX來提升UU：打造滿足新手和專家的UI",
              "startTime": "13:50",
              "endTime": "16:30",
              "checkinStatus": "CHECKIN",
              "info": {
                "introtext": 'test',
                "personnels": [
                  {
                    "name": "Jordan",
                    "categoryTitle": "工程師",
                    "companyName": "詠大心創意國際",
                    "title": "後端工程師",
                    "avatar": "avatar.jpg",
                    "description": null
                  },
                  {
                    "name": "Jerry",
                    "categoryTitle": "工程師",
                    "companyName": "詠大心創意國際",
                    "title": "後端工程師",
                    "avatar": "avatar.jpg",
                    "description": null
                  }
                ],
                "files": [],

              }
          }
      ]
  }
  ],
  "meal": [
      {
          "date": "2021-11-01",
          "value": "葷食餐點"
      }
  ],
  "brands": [
      {
          "alias": "aimetis",
          "logo": null
      },
      {
          "alias": "f5",
          "logo": null
      }
  ]
}

export const FAKE_ORDER_ITEM = FAKE_ORDER_ITEM_ONLINE_SINGLE_PARTIAL